<template>
  <ion-page>

    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <button type="button" @click="doRefresh" class="refresh_btn"><i class="far fa-sync"></i></button>
          <BackButton/>
        </ion-buttons>

        <ion-buttons slot="start" v-if="loginStatus && loginStatus.userId">
          <ion-menu-button>
            <ion-button id="right-menu-btn"><i class="fa fa-bars"></i></ion-button>
          </ion-menu-button>

        </ion-buttons>
        <ion-title v-html="pageTitle"></ion-title>
      </ion-toolbar>
    </ion-header>

    <div id="main-container" :key="'page-'+pageId+pageCounter">
      <slot  :key="'slot-'+pageId+pageCounter"></slot>
    </div>
    <div v-if="loginStatus && loginStatus.userId" class="tab-bottom-container" >
      <div class="tab-bottom-bar">
        <TabButton url="/Message/Manage">
          <div class="tab-icon">
            <i class="fal fa-envelope"></i>
            <div class="title">پیام ها</div>
          </div>
          <span v-if="messageCount" class="tab-badge">{{messageCount}}</span>
        </TabButton>

        <TabButton url="/">
          <div class="tab-icon">
            <i class="fal fa-home"></i>
            <div class="title">خانه</div>
          </div>
        </TabButton>

        <TabButton url="/order/list?status=-1">
          <div class="tab-icon">
            <i class="fal fa-clipboard-list"></i>
            <div class="title">فاکتورهای باز</div>
          </div>
          <span v-if="activeOrderCount" class="tab-badge">{{activeOrderCount}}</span>
        </TabButton>

      </div>
    </div>
  </ion-page>

</template>
<script>

import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonMenuButton,
  IonButton
} from "@ionic/vue";
import TabButton from "@/components/TabButton";
import {mapActions, mapGetters} from "vuex";
import BackButton from "@/components/BackButton";
import {fixCardTableSortBtn, makeCode} from "@/shared/helper"


export default {
  components: {
    BackButton,
    TabButton,
    IonPage, IonHeader, IonToolbar, IonTitle, IonMenuButton, IonButton,
  },
  data()
  {
    return {
      pageCounter:0,
      pageId:makeCode(12),
    }
  },
  props: ["pageTitle"],
  async mounted()
  {
    // this.getAndSaveMessageCount();
    // this.getAndSaveActiveOrderCount();
  },
  methods:{
    ...mapActions('app',{
      getAndSaveMessageCount:"getMessageCount",
      getAndSaveActiveOrderCount:"getActiveOrderCount"
    }),
    doRefresh()
    {
      this.pageCounter++
      this.$emit('refreshPage', {x:this.value1,y:this.value2})
    }
  },
  computed: {
    ...mapGetters("app", {
      messageCount: "getMessageCount",
      activeOrderCount: "getActiveOrderCount",
    }),
    ...mapGetters("auth", {
      loginStatus: "getAuthData",
    }),
  },
  watch:{
    "$route.path":function ()
    {
      fixCardTableSortBtn();
    }
  }
};
</script>
<style scoped>

.list-ios {
  height: 100%;
  overflow-y: auto;
}
.icon {
  font-size: 20px;
  margin-left: 15px;
  color: #00295e;
}
#right-menu-btn {
  border: none;
  background: none;
  color: #ffffff;
  font-size: 18px;
}
#right-menu-btn i{
  color: #ffffff;
  font-weight: lighter;
}
#right-menu-qrcode {
  border: none;
  background: none;
  color: #ffffff;
  font-size: 18px;
}
#right-menu-qrcode i{
  color: #ffffff;
  font-weight: lighter;
}
.toolbar-title-default {
  --background: #172e79;
}
ion-list a, ion-item{
  font-size: 13px;
}
.refresh_btn {
  background: transparent;
  color: #fff;
  font-size: 15px;
  padding: 14px;
  height: 45px;
  margin-top: -10px;
}
</style>